import React from "react";

const PaginationComponent = ({ page, setPage, filteredData, rowsPerPage }) => {
  const totalPages = Math.ceil(filteredData.length / rowsPerPage) || 1;

  return (
    <div
      className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 py-3 flex justify-center items-center z-50 shadow-md"
    >
      <div className="flex items-center gap-4">
        {/* Previous Button */}
        <button
          className="flex items-center gap-2 px-6 py-2 font-sans text-xs font-bold text-gray-900 uppercase rounded-lg transition-all hover:bg-gray-900/10 active:bg-gray-900/20 disabled:opacity-50"
          type="button"
          disabled={page === 0}
          onClick={() => setPage((prevPage) => prevPage - 1)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-4 h-4"
          >
            <path d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
          </svg>
          Previous
        </button>

        {/* Page Numbers */}
        <div className="flex items-center gap-2">
          {Array.from({ length: totalPages }).map((_, index) => (
            <button
              key={index}
              className={`relative h-10 w-10 rounded-lg text-center text-xs font-medium uppercase transition-all ${
                page === index
                  ? "bg-gray-900 text-white shadow-md"
                  : "text-gray-900 hover:bg-gray-900/10 active:bg-gray-900/20"
              }`}
              type="button"
              onClick={() => setPage(index)}
              disabled={page === index}
            >
              {index + 1}
            </button>
          ))}
        </div>

        {/* Next Button */}
        <button
          className="flex items-center gap-2 px-6 py-2 font-sans text-xs font-bold text-gray-900 uppercase rounded-lg transition-all hover:bg-gray-900/10 active:bg-gray-900/20 disabled:opacity-50"
          type="button"
          disabled={page === totalPages - 1}
          onClick={() => setPage((prevPage) => prevPage + 1)}
        >
          Next
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-4 h-4"
          >
            <path d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default PaginationComponent;
